import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, login, formatApiError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ocean-900 flex items-center justify-center p-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 text-sand-100/60 hover:text-gold text-sm font-mono mb-8 justify-center">
          <ArrowLeft className="w-4 h-4" /> Torna al sito
        </Link>
        <div className="bg-ocean-800 rounded-2xl border border-white/10 p-8">
          <div className="flex flex-col items-center mb-8">
            <Logo variant="light" className="h-16 w-auto mb-4" />
            <div className="flex items-center gap-2 text-gold font-mono text-xs tracking-[0.2em]">
              <Lock className="w-4 h-4" /> PANNELLO DI GESTIONE
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sand-100/70 text-sm mb-1.5 font-mono">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                className="w-full bg-ocean-900 border border-white/15 rounded-lg px-4 py-3 text-sand-100 focus:outline-none focus:border-gold"
                required
              />
            </div>
            <div>
              <label className="block text-sand-100/70 text-sm mb-1.5 font-mono">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                className="w-full bg-ocean-900 border border-white/15 rounded-lg px-4 py-3 text-sand-100 focus:outline-none focus:border-gold"
                required
              />
            </div>
            {error && <p className="text-coral text-sm" data-testid="admin-login-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full bg-coral hover:bg-coral/90 text-white font-heading font-bold py-3.5 rounded-full transition-all disabled:opacity-60"
            >
              {loading ? "Accesso..." : "ACCEDI"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
